import * as React from 'react';

function SvgLogoInstagram(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", d: "M16.166 3.667a4.18 4.18 0 014.168 4.166v8.333a4.18 4.18 0 01-4.168 4.168H7.833a4.18 4.18 0 01-4.166-4.168V7.833a4.18 4.18 0 014.166-4.166h8.333zm0-1.667H7.833C4.625 2 2 4.625 2 7.833v8.333C2 19.375 4.625 22 7.833 22h8.333C19.375 22 22 19.375 22 16.166V7.833C22 4.625 19.375 2 16.166 2z" }),
        React.createElement("path", { fill: "currentColor", d: "M17.416 7.834a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zM12 8.667a3.334 3.334 0 110 6.667 3.334 3.334 0 010-6.667zM12 7a5 5 0 100 10 5 5 0 000-10z" })));
}

export default SvgLogoInstagram;
